module.exports = __webpack_public_path__ + "static/media/Damage_insurance.3ac4da17.svg";